import { Component, HostListener, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import {Observable, of, Subject, switchMap} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {CdkConfigService} from '@cdk/services/config.service';
import {navigation} from 'app/navigation/navigation';
import {LoginService} from 'app/main/auth/login/login.service';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { NotificationComponent } from '../../../../notification/notification.component';
import { CdkScrollbarDirective } from '../../../../@cdk/directives/cdk-scrollbar/cdk-scrollbar.directive';
import { ContentComponent } from '../../components/content/content.component';
import { CdkSidebarComponent } from '../../../../@cdk/components/sidebar/sidebar.component';
import { AjudaPanelComponent } from '../../components/ajuda-panel/ajuda-panel.component';
import { ChatPanelComponent } from '../../components/chat-panel/chat-panel.component';
import { QuickPanelComponent } from '../../components/quick-panel/quick-panel.component';
import { ToolbarComponent } from '../../components/toolbar/toolbar.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { ShowIfRoleDirective } from '../../../../@cdk/directives/show-if-role.directive';

@Component({
    selector: 'vertical-layout-3',
    templateUrl: './layout-3.component.html',
    styleUrls: ['./layout-3.component.scss'],
    encapsulation: ViewEncapsulation.None,
        imports: [NotificationComponent, NgTemplateOutlet, CdkScrollbarDirective, ContentComponent, NgClass, CdkSidebarComponent, AjudaPanelComponent, ChatPanelComponent, QuickPanelComponent, ToolbarComponent, FooterComponent, NavbarComponent, ShowIfRoleDirective]
})
export class VerticalLayout3Component implements OnInit, OnDestroy {
    private _cdkConfigService = inject(CdkConfigService);

    cdkConfig: any;
    navigation: any;
    chatOpen: boolean = false;
    mobileMode: boolean;

    // Private
    private _unsubscribeAll: Subject<any>;
    private innerWidth: any;



    constructor() {
        this.navigation = navigation;
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event): void {
        this.innerWidth = window.innerWidth;
        this.mobileMode = innerWidth <= 600;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to config changes
        this._cdkConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.cdkConfig = config;
            });

        this.innerWidth = window.innerWidth;
        this.mobileMode = innerWidth <= 600;
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
    }

    toogleChat(isOpen: boolean): void {
        this.chatOpen = isOpen;
    }
}
